import {View} from 'MWC';
import tpl from '../templates/main';

export default class extends View {
    constructor(props) {
        super(props);
        this.state = {
            isUserTypeDropdownOpen: false
        };
    }
    template = tpl;

    toggleUserTypeDropdown = () => {
        this.setState(prev => ({
            isUserTypeDropdownOpen: !prev.isUserTypeDropdownOpen
        }));
    };

    changeUserType = type => {
        this.setState({isUserTypeDropdownOpen: false});
        this.props.changeUserType(type);
    };

    static displayName = 'Header.Views.MobileMainMenu';
}
